var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import DOMPurify from "dompurify";
import QuestionnaireOrg from "../../../organisms/jsQuestionnaire/jsQuestionnaire";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { AdviserFeedbackAction, AdviserFeedbackFormAction, ResetGlobalFormAction, } from "../../../../redux/actions/job_seeker_questionnaire";
import { questionnaireTimer } from "../../../../utils/QuestionnaireTimer";
import { getQuestionnaireAttemptVariant, getQuestionnaireProgressWidth, } from "../../../../utils/questionnaireProgress";
/**
 * The Adviser Feedback Questionnaire Page
 * This will need to call all relevant APIs to get the values.
 * @param props
 * @returns
 */
function AdviserFeedbackQuestionnaire() {
    var navigate = useNavigate();
    var dispatch = useDispatch();
    var _a = useState(""), error = _a[0], setError = _a[1];
    var _b = useState(false), isSubmitting = _b[0], setIsSubmitting = _b[1];
    //using selector hook to fetch data from the reducer
    var _c = useSelector(function (state) { return state.rootReducer.JobSeekerQuestionnaireReducer; }), adviserFeedbackData = _c.adviserFeedbackData, error_adviserFeedback = _c.error_adviserFeedback, loading = _c.loading, adviserFeedbackFormData = _c.adviserFeedbackFormData, success_adviserFeedback_form = _c.success_adviserFeedback_form, status = _c.status;
    useEffect(function () {
        questionnaireTimer.startSection("Adviser Feedback");
        // Antecedents prefetches this section already; only fetch if it's
        // not already cached in the store (e.g. direct navigation to this page).
        if (!adviserFeedbackData || adviserFeedbackData.length === 0) {
            dispatch(AdviserFeedbackAction());
        }
    }, [dispatch]);
    var loginData = useSelector(function (state) { return state.rootReducer.userReducer; }).loginData;
    var quesAttemptDetails = useSelector(function (state) { return state.rootReducer.dashboardReducer.quesAttemptDetails; });
    var handleBackBtn = function () {
        dispatch(ResetGlobalFormAction());
        navigate("/questionnaire/global");
    };
    //function to submit the input user data
    var handleFormSubmit = function (formData) {
        questionnaireTimer.endSection("Adviser Feedback");
        var sanitizedData = Object.keys(formData).reduce(function (acc, key) {
            acc[key] = DOMPurify.sanitize(formData[key]);
            return acc;
        }, {});
        setIsSubmitting(true);
        dispatch(AdviserFeedbackFormAction(sanitizedData, loginData));
    };
    useEffect(function () {
        if (success_adviserFeedback_form && isSubmitting) {
            navigate("/questionnaire/adviserImpact");
        }
    }, [success_adviserFeedback_form, isSubmitting, navigate]);
    useEffect(function () {
        if (success_adviserFeedback_form && isSubmitting) {
            navigate("/questionnaire/adviserImpact");
        }
    }, [success_adviserFeedback_form, isSubmitting, navigate]);
    return (_jsxs("div", __assign({ className: "" }, { children: [error && _jsx("div", __assign({ className: "error-message" }, { children: error })), _jsx(QuestionnaireOrg, { title: "Adviser Feedback", content: "For advisers and customers to work well together, it's important that they both understand what they need to do and what they expect from each other. So that we can best understand what a positive interaction looks like, please answer as honestly as possible.", data: adviserFeedbackData, responses: adviserFeedbackFormData, loading: !adviserFeedbackData || adviserFeedbackData.length === 0, handleSubmit: handleFormSubmit, handleBackBtn: handleBackBtn, classname: "adviserFeedback-w", width: getQuestionnaireProgressWidth("adviserFeedback", getQuestionnaireAttemptVariant(quesAttemptDetails)) })] })));
}
export default AdviserFeedbackQuestionnaire;
